import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DefinitionColonne } from '../entites/definition-colonne';

@Component({
  selector: 'app-selecteur-colonnes',
  templateUrl: './selecteur-colonnes.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelecteurColonnesComponent),
      multi: true
    }
  ]
})
export class SelecteurColonnesComponent implements ControlValueAccessor {
  @Input() colonnesDisponibles: DefinitionColonne[] = [];
  @Input() placeholder: string = 'Colonnes...';
  @Input() style: { [key: string]: string } = { minWidth: '200px' };
  @Input() selectedItemsLabel: string = '{0} colonnes sélectionnées';
  
  @Output() onReset = new EventEmitter<void>();
  @Output() onChange = new EventEmitter<{ value: DefinitionColonne[] }>();

  private _value: DefinitionColonne[] = [];
  private onTouched: () => void = () => {};
  private onChangeFn: (value: DefinitionColonne[]) => void = () => {};

  get value(): DefinitionColonne[] {
    return this._value;
  }

  set value(val: DefinitionColonne[]) {
    this._value = val;
    this.onChangeFn(val);
    this.onTouched();
  }

  writeValue(value: DefinitionColonne[]): void {
    this._value = value || [];
  }

  registerOnChange(fn: (value: DefinitionColonne[]) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onSelectionChange(event: { value: DefinitionColonne[] }): void {
    this.value = event.value;
    this.onChange.emit(event);
  }

  reinitialiserColonnes(): void {
    const colonnesParDefaut = this.colonnesDisponibles.filter(col => col.afficheParDefaut);
    this.value = colonnesParDefaut;
    this.onReset.emit();
    this.onChange.emit({ value: colonnesParDefaut });
  }
}

